import {FormControl, FormGroup, Validators} from "@angular/forms";
import {toString} from "../helpers/helpers";

export interface ItsmContactModel {
  id?: string;
  firstName?: string;
  lastName?: string;
  name?: string;
  phoneNumber?: string;
  phoneNumber2?: string;
  emailAddress?: string;
  businessPartnerId?: string;
  locale?: string;
  country?: string;
  language?: string;
  sourceSystem?: string;
  itsmContactId?: string;
  mailStop?: string;
  note?: string;
  contactTypes?: any;
  isHpContact?: boolean;
  siteId?: string;
  accountId?: string;
  resellerCustomerId?: string;
  relatedAccountIds?: string [];
}

export function itsmContactModelFactory(json?: any): ItsmContactModel {
  json = json || {};

  const firstName = toString(json.firstName);
  const lastName = toString(json.lastName);
  let name;
  if (firstName) name = lastName ? `${firstName} ${lastName}` : firstName;
  else if (lastName) name = lastName;
  else name = "unknown";

  return {
    id: toString(json.id),
    firstName,
    lastName,
    name,
    phoneNumber: toString(json.phoneNumber),
    phoneNumber2: toString(json.phoneNumber2),
    emailAddress: toString(json.emailAddress),
    businessPartnerId: toString(json.businessPartnerId),
    locale: toString(json.locale),
    country: toString(json.country),
    language: toString(json.language),
    sourceSystem: toString(json.sourceSystem),
    itsmContactId: toString(json.itsmContactId), // NOTE this must be set this way so that TMC knows what's valid
    mailStop: toString(json.mailStop),
    note: toString(json.note),
    contactTypes: json.contactTypes,
    isHpContact: json.isHpContact,
    siteId: json.siteId,
    accountId: json.account_id,
    resellerCustomerId: json.reseller_customer_id,
    relatedAccountIds: json.related_account_ids,
  };
}

export function itsmContactModelListFactory(json?: any): ItsmContactModel[] {
  return Array.from(json || []).map(it => itsmContactModelFactory(it)) as ItsmContactModel[];
}

export function itsmContactModelFormGroup(contact?: ItsmContactModel): FormGroup {
  contact = contact || itsmContactModelFactory();
  return new FormGroup({
    id: new FormControl("", [Validators.maxLength(50)]),
    firstName: new FormControl(contact.firstName, [Validators.maxLength(40)]),
    lastName: new FormControl(contact.lastName, [Validators.maxLength(40)]),
    phoneNumber: new FormControl(contact.phoneNumber, [Validators.maxLength(40)]),
    phoneNumber2: new FormControl(contact.phoneNumber2, [Validators.maxLength(40)]),
    emailAddress: new FormControl(contact.emailAddress, [Validators.required, Validators.maxLength(100)]),
    businessPartnerId: new FormControl(contact.businessPartnerId, [Validators.maxLength(11)]),
    locale: new FormControl(contact.locale, [Validators.maxLength(10)]),
    country: new FormControl(contact.country, [Validators.maxLength(10)]),
    language: new FormControl(contact.language, [Validators.maxLength(10)]),
    sourceSystem: new FormControl(contact.sourceSystem, [Validators.maxLength(10)]),
    itsmContactId: new FormControl(contact.itsmContactId, [Validators.maxLength(50)]),
    mailStop: new FormControl(contact.itsmContactId, [Validators.maxLength(50)]),
    note: new FormControl(contact.itsmContactId, [Validators.maxLength(500)]),
  });
}
